import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { usePrompt } from '@hooks/usePrompt';
import { Save } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import FAB from '@atoms/FAB';
import { UserAthlete } from '@type/db-types';

const SubmitWrestlerFAB = () => {
    const {
        formState: { isDirty, isLoading, isSubmitting, errors },
    } = useFormContext<UserAthlete>();

    const hasErrors = useMemo(() => {
        if (errors && Object.keys(errors).length > 0) {
            return !!errors;
        } else {
            return false;
        }
    }, [errors]);

    usePrompt(
        `You have unsaved changes which will be lost. \nAre you sure you want to leave?`,
        isDirty,
    );

    return (
        <FAB
            color="primary"
            disabled={!isDirty || isLoading || isSubmitting}
            toolTip={hasErrors ? <RenderError /> : 'Save Wrestler Details'}
            type="submit"
        >
            <Save />
        </FAB>
    );
};

export default memo(SubmitWrestlerFAB);

function RenderError() {
    const {
        formState: { errors },
    } = useFormContext<UserAthlete>();

    return (
        ['codeOfConduct', 'description', 'fee', 'imageUrl', 'name'] as (keyof UserAthlete)[]
    ).map((key) => {
        return errors[key]?.message ? <Typography>{errors[key]?.message}</Typography> : null;
    });
}
